import React, {Component} from "react";
import {View} from "react-native";
import WebView from "react-native-webview";

class Browser extends Component{

    render() {
        return (
            <View style={{flex:1}}>
                <WebView
                    source={{ uri: this.props.url }}
                    style={{ marginTop: 20,flex:1 }}
                    onError={(syntheticEvent) => {
                        const { nativeEvent } = syntheticEvent;
                        console.log('WebView error: ', nativeEvent);
                    }}
                />
            </View>
        );
    }
}
export default (Browser);
